/**
 * Removes reserve category (rescat) information from type well names.
 *
 * This function removes the last set of parentheses from well names, which represents
 * the reserve category. It preserves any other parentheses that are part of the
 * original well name.
 *
 * @param name - The original name that may contain rescat information
 * @returns The name with the last parentheses (rescat) removed
 *
 * @example
 * removeRescatFromTypeWellName("Type Well A (Oil) (P+PDP)") // returns "Type Well A (Oil)"
 * removeRescatFromTypeWellName("Type Well B (Gas)") // returns "Type Well B"
 * removeRescatFromTypeWellName("Regular Well") // returns "Regular Well"
 */
export function removeRescatFromTypeWellName(name: string): string {
  // Remove the last set of parentheses (which represents the rescat)
  // This matches optional whitespace, opening parenthesis, any content, closing parenthesis at the end
  return name.replace(/\s*\([^)]*\)$/, "");
}
